import { ResidentSelector, Alerts, HelpFooter } from "@common";

interface DashboardLayoutProps {
    children: React.ReactNode;
    alerts?: Array<{ title: string; content: React.ReactNode }>;
    isEmpty?: boolean;
}

const DashboardLayout = ({ children, alerts, isEmpty = false }: DashboardLayoutProps) => (
    <div className="flex flex-col w-full">
        {/* Alerts Center */}
        {alerts && alerts.length > 0 && (
            <>
                <Alerts alerts={alerts} />
                <div className="h-8" />
            </>
        )}

        {/* Dashboard Header */}
        <div className="border-b border-neutral-100 pb-6 flex items-center justify-between">
            <h1 className="text-[20px] leading-[24px] md:text-[28px] md:leading-[40px] font-medium text-neutral-950 tracking-[0.2px] md:tracking-[0.28px]">
                Dashboard
            </h1>
            <ResidentSelector />
        </div>

        {/* Spacing after header */}
        <div className="h-16" />

        {/* Main Content */}
        <div className="flex flex-col gap-16">
            {children}
        </div>

        {/* Flexible spacing before footer - pushes footer to bottom */}
        <div className={`flex-1 ${isEmpty ? `min-h-16` : `min-h-20`}`} />

        {/* Dashboard Footer */}
        <HelpFooter />
    </div>
);

export default DashboardLayout;
